import { create } from 'zustand';
import { combine } from 'zustand/middleware';

import { MAX_COMPARE_LIST_SIZE } from '../constants/product';
import type { ProductListItemType } from '../types/product';

type State = {
  productsList: Set<ProductListItemType>;
};

const initialState: State = {
  productsList: new Set<ProductListItemType>(),
};

export const useComparedProductsStore = create(
  combine({ ...initialState }, (set) => ({
    addProduct: (product: ProductListItemType) => {
      return set((state) => {
        const clone = { ...state };
        if (state.productsList.size < MAX_COMPARE_LIST_SIZE) {
          clone.productsList.add(product);
        }
        return clone;
      });
    },
    removeProduct: (product: ProductListItemType) => {
      return set((state) => {
        const clone = { ...state };
        clone.productsList = new Set([...clone.productsList].filter((e) => e.id !== product.id));
        return clone;
      });
    },
    removeAllProducts: () => {
      return set((state) => {
        const clone = { ...state };
        clone.productsList = new Set([]);
        return clone;
      });
    },
  })),
);
